import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { AutoLoginGuard } from "./guards/auto-login.guard";

const routes: Routes = [
  {
    path: "login",
    loadChildren: () =>
      import("./paginas/login/login.module").then((m) => m.LoginPageModule),
    canLoad: [AutoLoginGuard],
  },
  {
    path: "",
    loadChildren: () =>
      import("./paginas/tabs/tabs.module").then((m) => m.TabsPageModule),
    canLoad: [AuthGuard], // Aplicar sua guarda de autenticação
  },
  {
    path: "**",
    redirectTo: "",
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
